<div class="grid-container">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
      <legend class="usa-legend usa-legend--large">{{ title }}</legend>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-7 desktop:grid-col-7 text-right margin-x-auto margin-y-auto display-flex flex-column flex-align-end">
      <ul class="usa-button-group">
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="onComprehensiveReportClicked()">
            Comprehensive Report
          </button>
        </li>
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="onDelinquencyReportClicked()" >
            Delinquency Report
          </button>
        </li>
        <li class="usa-button-group__item">
          <button type="button" class="usa-button usa-button--secondary" (click)="onDelete()" [disabled]="isNoRowSelected$ | async">
            Delete Selected
          </button>
        </li>
      </ul>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-3">
      <p>ERRC requires TSPs to submit Shipment Reports within 60 calendar days after the quarter in which a shipment was invoiced. Because of this delay in reporting, shipments displayed for a selected Reporting Calendar Year/Reporting Quarter may
      not have been booked/delivered during the year/quarter queried.</p>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-bottom-205">
      <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      @if (gridOptions) {
        <ag-grid-angular style="height: 600px;" class="ag-theme-alpine" [components]="frameworkComponents" [gridOptions]="gridOptions"
          [rowData]="IFFShipmentPaginationResults$ | async"
          [enableCharts]="true"
          [enableRangeSelection]="true">
        </ag-grid-angular>
      }
    </div>
  </div>
</div>
